"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routerReplaceAll = exports.navigateToWxMiniprogram = exports.navigate = void 0;
var constant_1 = require("./constant");
/**
 * 路由处理
 */
var APP_ROUTE_PATH = {
    HOME: '/',
    LOGIN: '/welcome',
    COMMUNITY: '/communityIndex',
    COMMUNITY_PUBLISH: '/communityPublish',
    THE_CIRCLE_DETAIL: '/theCircleDetail'
};
/**
 * 跳转离线包页面
 * @param {*} path path 是 h5 alias
 */
/**
   * 跳转离线包页面
   * @param {*} path path 是 h5 alias
   * @param {*} routeKey routeKey 是 影射h5 alias 的key
   * @param {*} params params 是 传递的参数
   */
function navigate(_a) {
    var _b = _a.path, path = _b === void 0 ? '' : _b, _c = _a.routeKey, routeKey = _c === void 0 ? '' : _c, _d = _a.params, params = _d === void 0 ? [] : _d;
    if (!path && !routeKey) {
        console.error('path 和 routeKey 不能同时为空');
        return;
    }
    var lauchWebview = window.plus.webview.getLaunchWebview();
    var fullPath = '';
    // 直接传拼接好的路径
    // 如：`/communityIndex?tagId=${id}&contentId=${id}`
    if (path) {
        fullPath = path;
    }
    // 传递 routeKey 和参数
    if (routeKey) {
        fullPath = _routeKeyFormat(routeKey, params);
    }
    lauchWebview.evalJS("window.globalRouter.navigate(\"".concat(fullPath, "\")")); // 返回指定离线包路径
}
exports.navigate = navigate;
/**
   * 格式化路由路径
   * @param {*} routeKey
   * @param {*} params
   * @returns
   */
function _routeKeyFormat(routeKey, params) {
    if (routeKey === void 0) { routeKey = ''; }
    if (params === void 0) { params = []; }
    var fullPath = APP_ROUTE_PATH[routeKey];
    if (params && params.length) {
        fullPath += "?".concat(params.join('&'));
    }
    return fullPath;
}
/**
 * 跳转微信小程序
 * @param { WxMiniProgramOptions } wxMiniProgramOptions
 * @returns
 */
function navigateToWxMiniprogram(wxMiniProgramOptions) {
    return new Promise(function (resolve, reject) {
        try {
            var id_1 = wxMiniProgramOptions.appId, path_1 = wxMiniProgramOptions.appPath, envVersion_1 = wxMiniProgramOptions.envVersion;
            // 获取分享服务列表
            window.plus.share.getServices(function (s) {
                // 获取微信分享服务
                var shareService = s.find(function (item) { return item.id === 'weixin'; });
                // 判断是否支持微信分享
                if (!shareService) {
                    reject(new Error('当前环境不支持微信跳转操作'));
                    return;
                }
                // 判断是否已经授权
                if (shareService.authenticated) {
                    shareService.launchMiniProgram({ id: id_1, path: path_1, type: constant_1.EnvVersion[envVersion_1] }, function () {
                        resolve();
                    }, function (e) {
                        console.error("\u8DF3\u8F6C\u5931\u8D25\uFF1A".concat(JSON.stringify(e)));
                        reject(e);
                    });
                }
                else {
                    // 未授权则先授权
                    shareService.authorize(function () {
                        shareService.launchMiniProgram({ id: id_1, path: path_1, type: constant_1.EnvVersion[envVersion_1] }, function () {
                            resolve();
                        }, function (e) {
                            console.error("\u8DF3\u8F6C\u5931\u8D25\uFF1A".concat(JSON.stringify(e)));
                            reject(e);
                        });
                    }, function (e) {
                        console.error("\u83B7\u53D6\u5206\u4EAB\u670D\u52A1\u5217\u8868\u5931\u8D25\uFF1A".concat(JSON.stringify(e)));
                        reject(e);
                    });
                }
            }, function (e) {
                console.error("\u83B7\u53D6\u5206\u4EAB\u670D\u52A1\u5217\u8868\u5931\u8D25\uFF1A".concat(JSON.stringify(e)));
                reject(e);
            });
        }
        catch (error) {
            reject(error);
        }
    });
}
exports.navigateToWxMiniprogram = navigateToWxMiniprogram;
/**
 * replaceAll 路由跳转
 * @param toPath 去的路径
 * @param backPath 返回的路径，默认首页 '/'
 */
function routerReplaceAll(toPath, backPath) {
    if (backPath === void 0) { backPath = '/'; }
    if (!toPath) {
        console.error('path 不能为空');
        return;
    }
    var lauchWebview = window.plus.webview.getLaunchWebview();
    lauchWebview.evalJS("window.globalRouter.replaceAll(\"".concat(toPath, "\", \"").concat(backPath, "\")")); // 返回指定离线包路径
}
exports.routerReplaceAll = routerReplaceAll;
//# sourceMappingURL=route.js.map